module.exports = __webpack_public_path__ + "img/bg_figure3.27faaff5.png";